import UnityServiceApi from "@/unity-service-dashboard/api/UnityServiceApi";
import UGSVirtualPurchaseModel from "../classes/UGSVirtualPurchaseModel";
import UGSItemInventoryModel from "../classes/UGSItemInventoryModel";

export default {
    initDataStore(store){
        //assign from $store
        this.store = store;
    },

    getIconGroupIds(item){
        const tranformIconGroupList = this.store.state.tranformIconGroupList;
        if(item.iconGroupId && item.iconGroupId > 0 && tranformIconGroupList){
            let tGroup = tranformIconGroupList.find(t => t.groupId == item.iconGroupId);
            let groupIcons = [];
            tGroup.icons.forEach(i => groupIcons.push(i.replace(".png", "")));
            return groupIcons;
        } else {
            return undefined;
        }
    },

    doPushing(itemGroupData, onSuccess, onFailed){
        let itemInventory = new UGSItemInventoryModel(itemGroupData, this.getIconGroupIds(itemGroupData.item));
        let shopItem = new UGSVirtualPurchaseModel(itemGroupData, itemInventory);
        let ugsSetting = this.store.state.ugsSetting;
        UnityServiceApi.pushAddResource(itemInventory, shopItem, ugsSetting.environmentId,ugsSetting.isAutoPublish)
            .then(resultItem => {
                console.log("Result :", resultItem);
                onSuccess();
            })
            .catch(error => {
                onFailed(error);
            });
    },

    doPushingItems(itemGroupDatas, onSuccess, onFailed){
        let inventoryItems = [];
        let inventoryShops = [];
        itemGroupDatas.forEach(itemGroupData => {
            let itemInventory = new UGSItemInventoryModel(itemGroupData, this.getIconGroupIds(itemGroupData.item));
            inventoryItems.push(itemInventory);
            inventoryShops.push(new UGSVirtualPurchaseModel(itemGroupData, itemInventory));
        });

        let ugsSetting = this.store.state.ugsSetting;
        UnityServiceApi.pushAddResources(inventoryItems, inventoryShops, ugsSetting.environmentId,ugsSetting.isAutoPublish)
            .then(resultItem => {
                console.log("Result :", resultItem);
                onSuccess();
            })
            .catch(error => {
                onFailed(error);
            });
    },

    doPushingCustomItemsGameData(customId, itemsData,onSuccess, onFailed){
        let ugsSetting = this.store.state.ugsSetting;
        UnityServiceApi.setCustomItemsGameData(customId, itemsData, ugsSetting.environmentId)
            .then(resultItem => {
                console.log("Result :", resultItem);
                onSuccess();
            })
            .catch(error => {
                onFailed(error);
            });
    },

    doPullCustomItemsGameData(customId, keys,onSuccess, onFailed){
        let ugsSetting = this.store.state.ugsSetting;
        UnityServiceApi.getCustomItemsGameData(customId, keys, ugsSetting.environmentId)
            .then(resultItem => {
                console.log("Result :", resultItem);
                onSuccess();
            })
            .catch(error => {
                onFailed(error);
            });
    },
}